var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_745_8705)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_745_8705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2277 5.32614C14.1936 5.29196 10.9145 2.01465 10.5941 1.70059C10.5827 1.6892 10.5729 1.67943 10.5599 1.66967C9.96462 1.18474 9.10744 1.22868 8.56581 1.77219C8.10713 2.22945 8.13315 2.84293 8.14942 3.24161C8.15104 3.34413 8.1543 3.4499 8.1543 3.54754C8.1543 3.97225 7.75417 4.58736 7.13609 5.11459C6.49036 5.66624 5.74704 6.00308 5.32577 5.93473C5.22655 5.91846 5.13547 5.91033 5.05414 5.90382C5.01511 5.90056 4.98095 5.89731 4.94679 5.89405C2.95918 5.40099 2.06459 6.70606 1.96049 6.87041C1.80923 7.13403 1.84989 7.46599 2.06297 7.67754L4.236 9.85156L1.4642 13.6057C1.26739 13.8693 1.29504 14.2322 1.53089 14.4697C1.66101 14.5999 1.83017 14.6666 1.99933 14.6666C2.13596 14.6666 2.27258 14.6243 2.38807 14.5365L6.17949 11.7961L8.3265 13.9441C8.54283 14.1606 8.8779 14.2012 9.14627 14.0385C9.29591 13.9441 10.5971 13.0557 10.1173 11.1078C10.1124 11.0753 10.0848 10.8393 10.0701 10.7059C10.036 10.2893 10.4426 9.36013 11.103 8.64088C11.5714 8.13154 12.0512 7.85003 12.453 7.85003C12.5506 7.85003 12.6563 7.85165 12.7523 7.85491C13.1589 7.87281 13.7737 7.89884 14.2308 7.44158C14.5122 7.16007 14.6683 6.78579 14.6667 6.38549C14.6653 5.98518 14.5105 5.60928 14.2277 5.32614Z",
    stroke: "#95A4AD",
    strokeWidth: 1.33,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_745_8705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_745_8705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.d2c45da38c80a26fc201f9a7dbe05dc6.svg";
export { ForwardRef as ReactComponent };